const actionFieldList = [
    { id: 0, name: "工程项目-跟踪" },
    { id: 1, name: "工程项目-正式" },
    { id: 2, name: "工程项目-派审" },
    { id: 3, name: "耗材库存" },
    { id: 4, name: "权限" },
    { id: 5, name: "角色" },
    { id: 6, name: "用户" },
    { id: 7, name: "综合项目-跟踪" },
    { id: 8, name: "综合项目-正式" },
    { id: 9, name: "云资源" },
    { id: 10, name: "发票" },
    { id: 11, name: "车辆" },
    { id: 12, name: "代付" },
    { id: 100, name: "其他" },
]
export default actionFieldList